import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import IdentityPage from "./components/IdentityPage";
import Dashboard from "./components/Dashboard/Dashboard";
import ProtectedRoute from "./utils/ProtectedRoute";
import DashboardLayout from "./components/layout/DashboardLayout";
import Billing from "./features/billing/Billing";
import Ledger from "./features/billing/Ledger";
import CampaignView from "./features/whatsapp/Campaign/CampaignView";
import CampaignInsights from "./features/whatsapp/Insights";
import Campaign from "./features/whatsapp/Campaign/Campaign";
import Logs from "./features/whatsapp/Logs";
import TemplateStatus from "./features/whatsapp/Template/TemplateStatus";
import TemplateView from "./features/whatsapp/Template/TemplateView";
import CreateTemplate from "./features/whatsapp/Template/CreateTemplate";
import ContactBook from "./features/whatsapp/Chats/ContactBook";
import Chats from "./features/whatsapp/Chats/Chats";
import ChatBot from "./features/whatsapp/ChatBot";
import NewCampaign from "./features/whatsapp/New Campaign/NewCampaign";
import CampaignTable from "./features/whatsapp/New Campaign/CampaignTable";
import ProfileDashboard from "./features/settings/ProfileDashboard";
import PlanPricing from "./features/settings/PlanPricing";
import User from "./features/settings/User";
import ProfileSetting from "./features/settings/ProfileSetting";
import SetUp from "./features/settings/SetUp";
import Onboarding from "./features/whatsapp/Onboarding";
import CommonComingSoon from "./utils/CommingSoon";

import NoIndex from "./components/NoIndex";
import LoginPage from "./components/Login/Login";
import ContactDemo from "./components/Dashboard/ContactDemo";
import MainPage from "./components/LandingPage/HomePage";
import PrivacyPolicy from "./components/LandingPage/PrivacyPolicy";
import TermAndCondition from "./components/LandingPage/TermAndCondition";
import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminWhatsApp from "./components/Admin/AdminWhatsApp";
import AdminCampaigns from "./components/Admin/AdminCampaigns";
import AdminWhitelist from "./components/Admin/AdminWhitelist";
import ClientCreationPage from "./components/Admin/CreateClient";
import ProfileSection from "./components/Admin/ProfileSection";
import AdminLogin from "./components/Admin/AdminLogin";

function App() {
  const location = useLocation();

const adminId = "3";
const userId = "3";

  const adminData = {
    pkid: "3",
    id: "3",
    adname: "Dev Admin",
    userType: "admin",
  };

  useEffect(() => {
    const path = location.pathname;

    const formatTitle = (path) => {
      return path
        .split("/")
        .filter(Boolean)
        .map((word) => {
          return word
            .replace(/-/g, " ")
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
        })
        .join(" | ");
    };

    let title = formatTitle(path);

    if (path === "/") {
      title = "Home";
    }

    document.title = `${title} | Isancharr`;

    if (sessionStorage.getItem("user")) {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }
    }
  }, [location.pathname]);

  return (
    <>

      <NoIndex />
      <ToastContainer position="top-right" autoClose={2000} />

      <Routes>
        {/* Public Routes */}
        <Route
          path="/"
          element={<MainPage />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/Admin" element={<AdminLogin />} />
        <Route path="/contact-demo" element={<ContactDemo />} />
        {/* <Route path="/pricing" element={<PricingPage />} /> */}

        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermAndCondition />} />
        {/* <Route path="/get-started" element={<GetStarted />} /> */}
        {/* <Route path="/buy-plan/:planId" element={<BuyPlan />} /> */}
        <Route path="/identity" element={<IdentityPage />} />
        {/* <Route path="/pricing-page" element={<PricingPage />} /> */}

        {/* Protected Dashboard */}
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout adminId={adminId} userId={userId} />
            </ProtectedRoute>
          }
        >
          <Route path="/Dashboard" element={<Dashboard />} />
            <Route
        path="/admin/billing/:id"
        element={<ProfileSection Admin={adminData} />}
      />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
             <Route
        path="/admin/whatsapp"
        element={<AdminWhatsApp Admin={adminData} />}
      />

          <Route
        path="/admin/whatsappuser"
        element={<AdminCampaigns Admin={adminData} />}
      />

      <Route
        path="/admin/whitelist"
        element={<AdminWhitelist Admin={adminData} />}
      />

      <Route
        path="/admin/createclient"
        element={<ClientCreationPage Admin={adminData} />}
      />

          <Route path="/WhatsApp/*" element={<Campaign />} />
          <Route path="Whatsapp/Insights" element={<CampaignInsights />} />
          <Route path="/WhatsApp/Manage1" element={<CampaignTable />} />
          <Route path="/WhatsApp/NewCampaign" element={<NewCampaign />} />
          <Route
            path="/WhatsApp/Manage/CampaignView"
            element={<CampaignView />}
          />
          <Route path="/WhatsApp/Logs" element={<Logs />} />
          <Route path="/WhatsApp/Template" element={<TemplateStatus />} />
          <Route path="/WhatsApp/TemplateView" element={<TemplateView />} />
          <Route
            path="/WhatsApp/Create-Template"
            element={<CreateTemplate />}
          />
          <Route path="/WhatsApp" element={<Chats />} />
          <Route path="/WhatsApp/ContactBook" element={<ContactBook />} />
          <Route path="/WhatsApp/ChatBot" element={<ChatBot />} />
          <Route path="/WhatsApp/Onboarding" element={<Onboarding />} />
          <Route path="/Billing/*" element={<Billing />} />
          <Route path="/Billing/Ledger" element={<Ledger />} />
          <Route path="/Profile" element={<ProfileDashboard />} />
          <Route path="/Profile/Plans" element={<PlanPricing />} />
          <Route path="/Profile/UserManagement" element={<User />} />
          <Route path="/Profile/Setting" element={<ProfileSetting />} />
          <Route path="/Profile/Setup" element={<SetUp />} />

          <Route path="*" element={<CommonComingSoon />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
